<template>
  <div class="row">
    <div class="col-md-12 col-lg-12 ">
      <div class="search-bar">
        <div class="col-sm-12 no-padding">
            <div class="pull-left">
              <el-input v-model="searchQuery" @input="onInput()" :placeholder="$t('reports.search')" class="icon-search"></el-input>
            </div>
            <div class="pull-right">
              <router-link class="btn add " :title="$t('general.add') + ' ' + $t('marketingCoupons.single')" :to="{ path: '/marketing/coupons/add'}">
                <img src="/static/img/icons/add.png">
                {{ $t('general.add') }}
              </router-link>
            </div>
          </div>
      </div>
      <div class="card">
        <div class="card-content row">
          <data-tables class="coupons-table width-table"
                    v-loading="loading"
                    :data="tableData"
                    :action-def="defaultActionDef()"
                    :pagination-def="paginationDef"
                    :table-props="{'border': false}"
                    @row-click="goToRecord"
                    style="width: 100%">
            <el-table-column
              :min-width="45"
              prop="name"
              :label="$t('marketingCoupons.name')">
            </el-table-column>
            <el-table-column
              :min-width="35"
              prop="coupon_code"
              :label="$t('marketingCoupons.code')">
              <template slot-scope="props">
                <!-- Subscription coupon: compact pill (no code); the levels giving it are in the tooltip -->
                <span v-if="props.row.is_subscription"
                      class="coupon-sub-pill"
                      :title="subscriptionTitle(props.row)">
                  <i class="fa fa-ticket"></i>
                  {{ $t('marketingCoupons.subscriptionBadge') }}
                  <span v-if="props.row.subscription_levels && props.row.subscription_levels.length" class="coupon-sub-pill__count">{{ props.row.subscription_levels.length }}</span>
                </span>
                <!-- Automatic marketing coupon: compact pill + its informative code; the campaigns giving it are in the tooltip -->
                <template v-else-if="props.row.is_automation">
                  <span class="coupon-auto-pill" :title="automationTitle(props.row)">
                    <i class="fa fa-magic"></i>
                    {{ $t('marketingCoupons.automationBadge') }}
                    <span v-if="props.row.automation_campaigns && props.row.automation_campaigns.length" class="coupon-auto-pill__count">{{ props.row.automation_campaigns.length }}</span>
                  </span>
                  <span v-if="props.row.coupon_code" class="coupon-auto-code">{{ props.row.coupon_code }}</span>
                </template>
                <template v-else-if="props.row.coupon_has_multiple_codes">
                  {{ $t('marketingCoupons.multipleCodes') }} ({{ props.row.coupons_codes_count || 0 }})
                </template>
                <template v-else>{{ props.row.coupon_code }}</template>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="30"
              :label="$t('marketingCoupons.discount')">
              <template slot-scope="props">
                <template v-if="props.row.type === 'FREE_PRODUCT'">{{ $t('marketingCoupons.freeProduct') }}</template>
                <template v-else>{{ props.row.discount }} {{ props.row.type === 'FIXED' ? currency : '%' }}</template>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="45"
              :label="$t('marketingCoupons.validFromTo')">
              <template slot-scope="props">
                <template v-if="props.row.datetime_validfrom && props.row.datetime_validto">
                  {{formatDate(props.row.datetime_validfrom)}} - {{formatDate(props.row.datetime_validto)}}
                </template>
                <template v-else>-</template>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="25"
              :label="$t('marketingCoupons.daysLeft')">
              <template slot-scope="props">
                {{ props.row.datetime_validto ? getDaysLeft(props.row.datetime_validto) : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="45"
              :label="$t('marketingCoupons.pushCampaigns')">
              <template slot-scope="props">
                <template v-if="props.row.push_campaigns && props.row.push_campaigns.length">
                  <span v-for="campaign in props.row.push_campaigns"
                        :key="campaign.id"
                        class="coupon-badge coupon-badge--campaign">{{ campaign.name }}</span>
                </template>
                <span v-else class="coupon-badge coupon-badge--empty">{{ $t('marketingCoupons.notAssigned') }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="30"
              :label="$t('marketingCoupons.sources')">
              <template slot-scope="props">
                {{ orderSourcesText(props.row.order_source_ids) }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="25"
              :label="$t('marketingCoupons.status')"
              prop="active">
              <template slot-scope="props">
                <p-switch v-model="props.row.active" type="success" @input="handleActive(props.row)"></p-switch>
              </template>
            </el-table-column>
            <el-table-column
              :width="90"
              prop="actions"
              class-name="centered-cell"
              align="center"
              header-align="center"
              :label="$t('marketingCampaigns.actions')">
              <template slot-scope="props">
                <a class="btn btn-icon-small btn-danger" :title="$t('general.delete')" @click.stop="handleDelete(props.row)"><i class="fa fa-trash-o"></i></a>
              </template>
            </el-table-column>
            <el-table-column
              :width="160"
              class-name="centered-cell"
              align="center"
              header-align="center">
                <template slot-scope="props">
                  <div class="edit">
                    <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                  </div>
                </template>
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(DataTables)

  // same ids / labels as config('inmobito.order_sources') and ForthStep
  const ORDER_SOURCE_LABELS = {
    1: 'kiosk',
    2: 'qr',
    3: 'pos',
    4: 'app',
    5: 'website'
  }
  export default {
    components: {
      PSwitch
    },
    data () {
      return {
        loading: true,
        searchQuery: '',
        tableData: [],
        currency: '',
        paginationDef: {
          pageSize: 20,
          currentPage: 1,
          pageSizes: [20, 50, 100]
        }
      }
    },
    created () {
      this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso)
      this.getCoupons()
      this.$bus.$on('refresh', this.getCoupons)
    },
    beforeDestroy () {
      this.$bus.$off('refresh', this.getCoupons)
    },
    methods: {
      automationTitle (row) {
        const campaigns = row.automation_campaigns || []
        const hint = this.$t('marketingCoupons.isAutomationHint')
        if (!campaigns.length) {
          return hint
        }
        return this.$t('marketingCoupons.automationCampaigns') + ': ' + campaigns.map(campaign => campaign.name).join(', ') + '\n\n' + hint
      },
      subscriptionTitle (row) {
        const levels = row.subscription_levels || []
        const hint = this.$t('marketingCoupons.isSubscriptionHint')
        if (!levels.length) {
          return hint
        }
        return this.$t('marketingCoupons.subscriptionLevels') + ': ' + levels.map(level => level.name).join(', ') + '\n\n' + hint
      },
      orderSourcesText (ids) {
        if (!Array.isArray(ids) || !ids.length) {
          return this.$t('marketingCoupons.allSources')
        }
        return ids.map(id => {
          const label = ORDER_SOURCE_LABELS[id] || String(id)
          const key = 'orderFrom.' + label
          const translated = this.$t(key)
          if (translated !== key) {
            return translated
          }
          const upperKey = 'orderFrom.' + label.toUpperCase()
          const upperTranslated = this.$t(upperKey)
          return upperTranslated !== upperKey ? upperTranslated : label
        }).join(', ')
      },
      requestData () {
        return {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
      },
      getCoupons () {
        const data = this.requestData()
        if (this.searchQuery.length >= 3) {
          data.search = this.searchQuery
        }
        this.loading = true
        this.apiRequest('/coupon', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })
      },
      onInput () {
        if (this.searchQuery.length >= 3 || this.searchQuery.length === 0) {
          this.getCoupons()
        }
      },
      goToRecord (row, column, event) {
        this.globalGoToRecord(row, event, column, '/marketing/coupons/edit/')
      },
      handleActive (row) {
        const data = {
          ...this.requestData(),
          active: row.active ? 1 : 0
        }
        this.apiRequest('/coupon/' + row.id + '/status', 'POST', data, (response) => {
          if (response.status) {
            swal(this.$t('general.success') + '!', '', 'success').catch(() => {})
          } else {
            row.active = !row.active
            swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
          }
        })
      },
      handleDelete (row) {
        let text = this.$t('marketingCoupons.areYouSureDelete') + ' ' + row.name + '?'
        if (row.push_campaigns && row.push_campaigns.length) {
          text += ' ' + this.$t('marketingCoupons.deleteAssignedWarning', {
            campaigns: row.push_campaigns.map(campaign => campaign.name).join(', ')
          })
        }
        swal({
          text: text,
          type: 'question',
          showCancelButton: true
        }).then((result) => {
          if (!result) {
            return
          }
          this.apiRequest('/coupon/' + row.id, 'DELETE', this.requestData(), (response) => {
            if (response.status === true) {
              swal('', this.$t('marketingCoupons.couponDeleted'), 'success').catch(() => {})
              this.tableData = this.tableData.filter(item => item.id !== row.id)
            } else {
              swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
            }
          })
        }).catch(() => {})
      }
    }
  }
</script>
<style>
  .coupons-table .centered-cell .cell {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .coupon-badge {
    display: inline-block;
    margin: 2px 4px 2px 0;
    padding: 3px 8px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 1.4;
    white-space: normal;
  }
  .coupon-badge--campaign {
    background: #ede7f6;
    color: #5e35b1;
    border: 1px solid #d1c4e9;
  }
  .coupon-sub-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    line-height: 1.5;
    white-space: nowrap;
    background: #e3f2fd;
    color: #1565c0;
    border: 1px solid #bbdefb;
    cursor: default;
  }
  .coupon-sub-pill__count {
    min-width: 16px;
    padding: 0 4px;
    border-radius: 8px;
    background: #1565c0;
    color: #fff;
    font-size: 10px;
    text-align: center;
  }
  .coupon-auto-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    line-height: 1.5;
    white-space: nowrap;
    background: #f3eefb;
    color: #5e35b1;
    border: 1px solid #d1c4e9;
    cursor: default;
  }
  .coupon-auto-code {
    display: block;
    margin-top: 3px;
    font-size: 12px;
    color: #777;
  }
  .coupon-auto-pill__count {
    min-width: 16px;
    padding: 0 4px;
    border-radius: 8px;
    background: #5e35b1;
    color: #fff;
    font-size: 10px;
    text-align: center;
  }
  .coupon-badge--empty {
    background: #f5f5f5;
    color: #777;
    border: 1px solid #e0e0e0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/DiscountCoupons/Coupons.vue